// src/firebase.js

// Firebase Core
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

// Your Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyCCwF5rwFrAbs7JjL8WVdWkS5xDBbXRNvo",
  authDomain: "convalesce-app-7211f.firebaseapp.com",
  projectId: "convalesce-app-7211f",
  storageBucket: "convalesce-app-7211f.appspot.com",
  messagingSenderId: "1092304346647",
  appId: "1:1092304346647:web:4006cb911d4b49dc2c0652",
};

// Initialize app once
const app = initializeApp(firebaseConfig);

// Export main Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Optional: FCM Messaging (only if supported by browser)
let messaging = null;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    }
  });
}

export { app, messaging };
